import { defineStore } from "pinia";

export const usePersistentStore = defineStore("persistent", {
  state: () => ({
    currentlyLoggedInBand: null,
    disableProfileTextNotificationsStep: false,
    uniqueId: null,
    customerEmail: null,
    customerName: null,
    selectedCurrency: {
      value: "USD",
      text: "USD",
      name: "United States Dollar",
      symbol: "$",
    },
    localSongPasses: [],
    userVotingForGigs: {},
    // kidzbop over 18
    hasBeenAskedForAge: false,
    isOver18: false,
    optIntoEmails: false,
    hasOptedIntoEmails: false,
  }),

  getters: {
    currentlyLoggedInBandParsed: (state) =>
      state.currentlyLoggedInBand ? JSON.parse(state.currentlyLoggedInBand) : undefined,
  },

  actions: {
    setCustomerName(value) {
      this.customerName = value;
    },

    setCurrentlyLoggedInBand(band) {
      const stringifiedBand = JSON.stringify(Object.assign({}, band));
      this.currentlyLoggedInBand = stringifiedBand;
    },

    setDisableProfileTextNotificationsStep(value) {
      this.disableProfileTextNotificationsStep = value;
    },

    setUniqueId(value) {
      this.uniqueId = value;
    },

    setCustomerEmail(value) {
      this.customerEmail = value;
    },

    setSelectedCurrency(value) {
      this.selectedCurrency = value;
    },

    setLocalSongPasses(value) {
      this.localSongPasses = value;
    },

    setHasOptedIntoEmails(value) {
      this.hasOptedIntoEmails = value;
    },

    reportTipAtGig(gigId) {
      if (!this.userVotingForGigs[gigId]) {
        this.userVotingForGigs[gigId] = {
          numVotes: 1,
        };
      } else {
        this.userVotingForGigs[gigId].numVotes += 1;
      }
    },

    setIsOver18(value) {
      this.isOver18 = value;
      this.hasBeenAskedForAge = true;
    },

    setOptIntoEmails(value) {
      this.optIntoEmails = value;
    },
  },

  persist: {
    storage: localStorage,
    paths: [
      "currentlyLoggedInBand",
      "disableProfileTextNotificationsStep",
      "uniqueId",
      "customerEmail",
      "customerName",
      "selectedCurrency",
      "localSongPasses",
      "userVotingForGigs",
      "hasBeenAskedForAge",
      "isOver18",
      "optIntoEmails",
      "hasOptedIntoEmails",
    ],
  },
});
